<template>
  <div class="nutritionist-detail">
    <AppNavbar
      :options="options"
      :placeholder="true"
      title="营养师详情"
    ></AppNavbar>
    <CoachDetail
      :data="coachData"
      v-if="coachData"
      v-pageBuried
      data-page-buried="BG_XINBANYYSXQ"
      :data-eventv="'BG_XINBANYYSXQ_' + id"
    ></CoachDetail>
  </div>
</template>

<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import CoachDetail from './components/nutritionist-detail/item-1.vue'

import { coachDataList } from './coach-data.js'
export default {
  name: 'app-camp-nutritionist-detail',
  components: { CoachDetail, AppNavbar },
  data() {
    return {
      id: 0,
      options: {
        barBackgroundColor: 'rgb(255,255,255)',
        color: '#333'
      },
      coachData: null
    }
  },
  created() {
    this.id = this.$route.query.id
    coachDataList.map((item) => {
      if (item.id == this.id) {
        this.coachData = item
      }
    })
    if (!this.coachData) {
      this.$toast('营养师不存在')
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.nutritionist-detail {
  background: #f5f5f5;
}
</style>
